import API from "../api/client";

// The form-replies module's own API calls (api/formreplies). Admin only on the
// server: every route sits behind RouteAdminOnly.

export function formRepliesGET() {
	return API.get("/form_replies");
}

export function formReplyPreviewPOST(key, template) {
	return API.post("/form_replies/preview", { key, ...template });
}

export function formReplyPATCH(key, template) {
	return API.patch("/form_replies/" + encodeURIComponent(key), template);
}

export function formReplyDELETE(key) {
	return API.delete("/form_replies/" + encodeURIComponent(key));
}
